import React from 'react'
import ContentLoader from 'react-content-loader'
import { useTheme } from 'styled-components'

import { useIsMobile } from 'utils/useIsMobile'

export const ActivityHistoryContentLoader: React.FC = () => {
  let rowHeight = 80
  let rowCount = 6
  let baseY = 40
  let totalHeight = baseY + (rowCount - 1) * rowHeight + 40

  const theme = useTheme()
  const isMobile = useIsMobile()

  if (isMobile) {
    rowHeight = 60
    rowCount = 4
    baseY = 20
    totalHeight = baseY + rowCount * rowHeight - 40

    const padding = 16
    const columnWidth = 152
    const gap = 8

    return (
      <ContentLoader
        speed={2}
        width="100%"
        height={totalHeight}
        backgroundColor={theme.colors.contentLoader.backgroundColor}
        foregroundColor={theme.colors.contentLoader.foregroundColor}
        viewBox={`0 0 375 ${totalHeight}`}
      >
        {Array.from({ length: rowCount }).map((_, i) => {
          const y = baseY + i * rowHeight
          return (
            <React.Fragment key={i}>
              <rect x={padding} y={y} rx="4" ry="4" width={columnWidth} height="20" />
              <rect x={padding + columnWidth + gap} y={y} rx="4" ry="4" width={columnWidth} height="20" />
              <circle cx={375 - padding - 10} cy={y + 10} r="10" />
            </React.Fragment>
          )
        })}
      </ContentLoader>
    )
  }

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={totalHeight}
      backgroundColor={theme.colors.contentLoader.backgroundColor}
      foregroundColor={theme.colors.contentLoader.foregroundColor}
      viewBox={`0 0 1200 ${totalHeight}`}
    >
      {Array.from({ length: rowCount }).map((_, i) => {
        const y = baseY + i * rowHeight
        return (
          <React.Fragment key={i}>
            <rect x="20" y={y} rx="4" ry="4" width="200" height="20" />
            <rect x="240" y={y} rx="4" ry="4" width="200" height="20" />
            <rect x="460" y={y} rx="4" ry="4" width="600" height="20" />
            <circle cx="1160" cy={y + 10} r="20" />
          </React.Fragment>
        )
      })}
    </ContentLoader>
  )
}
